import Axios from 'axios'
import { defaultSetting, interceptRequest, processResponse, processError } from '@/util/axios_common'

// 共通設定
const axiosNoError = Axios.create(defaultSetting)

// リクエストを送るときの共通処理
axiosNoError.interceptors.request.use((request) => {
  return interceptRequest(request, false)
})

// レスポンスを受け取ったときの共通処理
axiosNoError.interceptors.response.use((response) => {

  return processResponse(response, false)

}, error => {
  // interceptRequest()のトークンnullの場合のthrow Axios.Cancel()が実行された場合もここに飛んでくる

  processError(error)

})

export default axiosNoError
